import { render, staticRenderFns } from "./GlobalConfiguration.vue?vue&type=template&id=acc9ef58&scoped=true"
import script from "./GlobalConfiguration.vue?vue&type=script&lang=js"
export * from "./GlobalConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc9ef58",
  null
  
)

export default component.exports